import PropTypes from 'prop-types';
import React from 'react';
import BriefStore from 'contest/stores/brief-store';
import { connectToStores } from 'fluxible-addons-react';

import InfoBox from '@99designs/react-components/components/InfoBox';

const RawHtml = ({ html }) => <div dangerouslySetInnerHTML={{ __html: html }} />;

RawHtml.propTypes = {
    html: PropTypes.string.isRequired,
};

const ChoiceHtmlInfoBox = ({ info }) => (
    <InfoBox isDismissable={false}>
        {info.map((infoText, index) => <RawHtml key={index} html={infoText} />)}
    </InfoBox>
);

ChoiceHtmlInfoBox.propTypes = {
    info: PropTypes.array,
};

export const ConnectedChoiceHtmlInfoBox = ({ element }) => {
    const info = element.trans.infoBoxChoices[element.value];

    if (info && info.length > 0) {
        return <ChoiceHtmlInfoBox info={info} />;
    } else {
        return null;
    }
};

ConnectedChoiceHtmlInfoBox.propTypes = {
    element: PropTypes.shape({
        trans: PropTypes.shape({
            helpBoxInfo: PropTypes.array,
        }),
    }),
};

const ViewInfoBoxSelector = ({ infoBoxType, element }) => {
    if (infoBoxType === 'choiceHtml') {
        return <ConnectedChoiceHtmlInfoBox element={element} />;
    } else {
        return null; // React needs null specifically to not render
    }
};

ViewInfoBoxSelector.propTypes = {
    infoBoxType: PropTypes.string.isRequired,
    element: PropTypes.object,
};

export const ConnectedViewInfoBoxSelector = connectToStores(
    ViewInfoBoxSelector,
    [BriefStore],
    (context, props) => {
        const store = context.getStore(BriefStore);
        const element = store.outline[props.sectionKey].elements[props.elementKey];
        return {
            infoBoxType: (element.infoBox && element.infoBox.type) || '',
            element: element,
            dismissKey: `${props.sectionKey}:${props.elementKey}:${props.listingId}`,
        };
    }
);

ConnectedViewInfoBoxSelector.propTypes = {
    elementKey: PropTypes.string.isRequired,
    sectionKey: PropTypes.string.isRequired,
    listingId: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/view-info-box.jsx